import { useEffect, useRef, useState } from 'react';

export default function NotesCta() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-20 md:py-28 bg-[#2c2420]">
      <div
        className={`w-full px-6 md:px-12 lg:px-20 flex flex-col items-center text-center transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
      >
        <div className="flex items-center justify-center gap-3 mb-7">
          <div className="w-8 h-px bg-[#c8b89a]/40"></div>
          <span className="text-[0.8125rem] tracking-[0.2em] text-[#c8b89a]/70 font-medium uppercase">Contact</span>
          <div className="w-8 h-px bg-[#c8b89a]/40"></div>
        </div>

        <h2
          className="font-serif-tc text-[#f5ede0] leading-[1.4] mb-5 max-w-xl"
          style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)' }}
        >
          看完文章之後，<br />如果有任何想聊的
        </h2>

        <p className="text-[1.0625rem] leading-[1.8] text-[#c8b89a]/70 max-w-md mb-10">
          不急著報名，不需要準備答案。<br />
          加入 LINE@ 告訴我你現在的狀態，<br />
          我們先聊聊，再決定下一步。
        </p>

        <a
          href="https://line.me"
          target="_blank"
          rel="noopener nofollow"
          className="px-8 py-4 rounded-full bg-[#c8b89a] text-[#2c2420] text-[1rem] font-medium hover:bg-[#d4c4aa] transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          加入 LINE@ 諮詢
        </a>

        <p className="mt-6 text-[0.875rem] text-[#7a6e62]">
          加入不等於報名・不催促・尊重你的步調
        </p>
      </div>
    </section>
  );
}
